import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalasedancab() {



  const cardData = {




keyword: "Pune to Lonavala Sedan Cabs",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Lonavala Sedan Cabs for couples, families, senior citizens, and small groups planning a convenient hill-station journey. Our chauffeur-driven sedans are suitable for one-way travel, round trips, weekend trips, sightseeing, and customized Lonavala travel plans. With clean and well-maintained cars, experienced drivers, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, we make the journey smooth and convenient. Customers can also include nearby attractions, viewpoints, lakes, forts, and hill destinations in their itinerary while enjoying private door-to-door transportation throughout the trip.",

topPlaces: [
  {
    title: "Karla Caves",
    description: "Karla Caves are ancient rock-cut Buddhist caves located near Lonavala and are particularly known for the impressive Grand Chaitya, one of the prominent surviving prayer halls from the period. The site is an interesting stop for travelers who enjoy history, architecture, and heritage attractions. A private sedan from Pune makes it convenient for couples and families to visit Karla Caves as part of a customized Lonavala sightseeing journey."
  },
  {
    title: "Bhaja Caves",
    description: "Bhaja Caves are historic rock-cut caves located in the scenic hills near Lonavala and feature ancient Buddhist architecture, stupas, and carved structures. The surrounding landscape makes the area appealing to history enthusiasts and nature lovers alike. Garud Cab Service provides chauffeur-driven sedan transportation from Pune, allowing travelers to comfortably include Bhaja Caves in their Lonavala trip."
  },
  {
    title: "Rajmachi Fort",
    description: "Rajmachi is a historic fort destination surrounded by the beautiful Sahyadri mountains and is popular among trekking enthusiasts, photographers, and nature lovers. The region offers scenic valleys and forest landscapes, especially during the monsoon. A sedan cab can conveniently take travelers from Pune toward the Rajmachi region, with suitable arrangements for the road-access portion of the journey."
  },
  {
    title: "Kamshet",
    description: "Kamshet is a scenic destination near Lonavala known for its surrounding hills, lakes, greenery, and adventure activities, particularly paragliding. It is a good option for travelers who want to combine a Lonavala trip with outdoor experiences. Customers can book a private sedan from Pune and customize their itinerary to include Kamshet along with other nearby attractions."
  },
  {
    title: "Pawna Lake",
    description: "Pawna Lake is a picturesque lakeside destination surrounded by hills and historic forts, making it popular for camping, photography, peaceful getaways, and weekend trips. Couples and small families can enjoy a private road journey from Pune in a comfortable sedan. Garud Cab Service can arrange direct or return transportation with flexible travel timings based on the customer's sightseeing plan."
  },
  {
    title: "Lohagad Fort",
    description: "Lohagad Fort is a historic hill fort near Lonavala that offers scenic views of the surrounding valleys and is a popular destination for history enthusiasts and trekking visitors. The fort area becomes particularly attractive during the monsoon when the surrounding hills turn green. A chauffeur-driven sedan provides comfortable transportation from Pune to the accessible area near the fort."
  },
  {
    title: "Visapur Fort",
    description: "Visapur Fort is a prominent hill fort near Lonavala offering expansive views of the Sahyadri landscape and nearby valleys. It is popular among trekkers, photographers, and visitors interested in Maharashtra's historic forts. Travelers booking Pune to Lonavala Sedan Cabs can include the Visapur region in their itinerary and enjoy private transportation between sightseeing stops."
  },
  {
    title: "Kune Waterfalls",
    description: "Kune Waterfalls is a scenic waterfall attraction in the Lonavala-Khandala region surrounded by lush greenery and dramatic mountain scenery. It is especially attractive during the monsoon season when water flow increases and the landscape becomes vibrant. A private sedan from Pune provides a convenient option for families and couples who want to explore Kune Waterfalls along with nearby attractions."
  },
  {
    title: "Duke's Nose",
    description: "Duke's Nose is a distinctive rocky viewpoint in the Khandala region offering panoramic views of the surrounding valleys and Western Ghats. The location is popular among trekkers, adventure enthusiasts, and photographers. Garud Cab Service can provide a comfortable sedan for the Pune journey, allowing travelers to include Duke's Nose and nearby Khandala attractions in a customized sightseeing plan."
  },
  {
    title: "Valvan Lake",
    description: "Valvan Lake is a peaceful waterbody near Lonavala surrounded by greenery and hill landscapes, providing a quieter sightseeing experience away from some of the busier tourist locations. It is suitable for visitors looking for scenic views and relaxed travel. Customers can book a private sedan from Pune for a comfortable Lonavala journey and include Valvan Lake as one of their planned stops."
  }
],




"services": [
{
"name": "Lonavala Sedan Cab from Pune",
"description": "Book Lonavala Sedan Cab from Pune for a comfortable and convenient journey to Lonavala with a professional chauffeur and well-maintained air-conditioned sedan. The service is suitable for couples, families, tourists, weekend travelers, sightseeing trips, day tours, and private outstation travel."
},
{
"name": "Pune to Lonavala Taxi Fare",
"description": "Check Pune to Lonavala Taxi Fare according to your selected sedan, passenger count, travel requirements, and journey type. Enjoy comfortable AC transportation with professional chauffeur service for one-way transfers, round trips, sightseeing, family trips, weekend travel, and planned Lonavala tours."
},
{
"name": "Pune to Lonavala Tourist Taxi",
"description": "Choose Pune to Lonavala Tourist Taxi for comfortable private sightseeing and tourist transportation with an experienced chauffeur. The service is suitable for couples, families, small groups, weekend travelers, and visitors planning to explore Lonavala and nearby attractions with flexible travel arrangements."
},
{
"name": "Pune to Lonavala Weekend Trip Cab",
"description": "Book Pune to Lonavala Weekend Trip Cab for a convenient private weekend journey with comfortable AC travel and professional chauffeur service. Enjoy flexible pickup, spacious seating, practical luggage capacity, and a suitable sedan for couples, families, friends, and small groups."
},
{
"name": "Pune to Lonavala Outstation Taxi",
"description": "Reserve Pune to Lonavala Outstation Taxi for reliable intercity transportation with an experienced chauffeur and clean air-conditioned sedan. The service is suitable for one-way travel, round trips, family journeys, sightseeing, weekend holidays, personal visits, and private outstation transportation."
},
{
"name": "Pune to Lonavala Sedan Car Hire",
"description": "Hire Pune to Lonavala Sedan Car with a professional chauffeur for comfortable and stress-free travel. Enjoy AC interiors, comfortable seating, practical luggage space, convenient pickup, and flexible travel options for individuals, couples, families, tourists, and groups visiting Lonavala."
},
{
"name": "Pune to Lonavala Family Tour Cab",
"description": "Choose Pune to Lonavala Family Tour Cab for comfortable private transportation with family-friendly seating, AC interiors, luggage space, and an experienced chauffeur. The service is suitable for family outings, sightseeing, weekend holidays, day trips, and planned Lonavala travel."
},
{
"name": "Pune to Lonavala Day Trip Cab",
"description": "Book Pune to Lonavala Day Trip Cab for a convenient same-day journey with private chauffeur-driven transportation. Enjoy comfortable AC travel, flexible pickup and return arrangements, and convenient sightseeing options for couples, families, friends, and small groups planning a one-day Lonavala trip."
},
{
"name": "Pune to Lonavala Budget Cab",
"description": "Choose Pune to Lonavala Budget Cab for economical and comfortable private transportation with a professional chauffeur and air-conditioned sedan. The service is suitable for individuals, couples, families, students, tourists, and small groups looking for practical travel for day trips and weekend journeys."
},
{
"name": "Pune to Lonavala Cab Tour Package",
"description": "Book Pune to Lonavala Cab Tour Package for a convenient private tour with chauffeur-driven transportation and flexible sightseeing arrangements. Enjoy comfortable AC travel, convenient pickup, and a suitable sedan for families, couples, tourists, friends, and groups exploring Lonavala."
},
{
"name": "Pune to Lonavala Tour Package",
"description": "Choose Pune to Lonavala Tour Package for a comfortable private journey planned according to your sightseeing and travel schedule. Enjoy professional chauffeur service, AC sedan transportation, flexible pickup, convenient sightseeing, and return travel options for families, couples, tourists, and groups."
},
{
"name": "Pune to Lonavala Sightseeing Package",
"description": "Book Pune to Lonavala Sightseeing Package for convenient private transportation to explore popular attractions around Lonavala. Travel in a comfortable AC sedan with an experienced chauffeur and enjoy flexible sightseeing arrangements suitable for families, couples, tourists, friends, and small groups."
},
{
"name": "Pune to Lonavala Cab Package",
"description": "Reserve Pune to Lonavala Cab Package for comfortable chauffeur-driven transportation with flexible one-way, return, and sightseeing options. Choose a suitable sedan for your group and enjoy convenient pickup, air-conditioned travel, luggage space, and private transportation throughout your Lonavala trip."
},
{
"name": "Pune to Lonavala Tourist Package",
"description": "Choose Pune to Lonavala Tourist Package for a private sightseeing journey with comfortable AC sedan transportation and professional chauffeur service. The package is suitable for tourists, couples, families, friends, and small groups planning a relaxed visit to Lonavala and nearby attractions."
},
{
"name": "Pune to Lonavala One Day Tour Package",
"description": "Book Pune to Lonavala One Day Tour Package for a convenient same-day sightseeing trip with private chauffeur-driven transportation. Enjoy flexible pickup and return timing, comfortable AC travel, practical luggage space, and sightseeing arrangements suitable for families, couples, friends, and tourists."
},
{
"name": "Pune to Lonavala Family Tour Package",
"description": "Choose Pune to Lonavala Family Tour Package for comfortable private transportation and flexible sightseeing during your family holiday. Travel in an AC sedan with professional chauffeur service, convenient pickup, comfortable seating, and practical luggage space for a relaxed day or weekend trip."
},
{
"name": "Pune to Lonavala Taxi Package",
"description": "Book Pune to Lonavala Taxi Package for convenient private transportation with an experienced chauffeur and comfortable air-conditioned sedan. The package is suitable for one-way travel, return journeys, sightseeing, family trips, weekend holidays, personal visits, and customized Lonavala travel plans."
},
{
"name": "Pune to Lonavala Holiday Package",
"description": "Choose Pune to Lonavala Holiday Package for a comfortable private holiday journey with chauffeur-driven AC transportation and flexible sightseeing options. The service is suitable for families, couples, friends, tourists, and small groups planning a relaxing weekend or extended Lonavala getaway."
},
{
"name": "Pune to Lonavala Weekend Tour Package",
"description": "Book Pune to Lonavala Weekend Tour Package for convenient private transportation during your weekend holiday. Enjoy comfortable AC sedan travel, professional chauffeur service, flexible pickup and return arrangements, and sightseeing options for families, couples, friends, and tourist groups."
},
{
"name": "Pune to Lonavala Darshan Package",
"description": "Choose Pune to Lonavala Darshan Package for a comfortable private journey covering temples and places of interest around the Lonavala region. Enjoy chauffeur-driven AC transportation, convenient pickup, flexible sightseeing, and return travel arrangements for families, devotees, tourists, and small groups."
},
{
"name": "Pune to Lonavala Cab Booking Package",
"description": "Make Pune to Lonavala Cab Booking Package for scheduled private transportation with convenient pickup and destination arrangements. Select a comfortable AC sedan according to your group size and enjoy professional chauffeur service for sightseeing, day trips, weekend holidays, family travel, and tourist journeys."
},
{
"name": "Pune to Lonavala Round Trip Package",
"description": "Book Pune to Lonavala Round Trip Package for convenient return transportation according to your planned itinerary. Enjoy private AC travel, experienced chauffeur service, flexible sightseeing, comfortable seating, and practical luggage space for families, couples, friends, tourists, and small groups."
},
{
"name": "Pune to Lonavala Tourist Cab Package",
"description": "Choose Pune to Lonavala Tourist Cab Package for comfortable private sightseeing with an experienced chauffeur and air-conditioned sedan. The package is suitable for tourists, families, couples, friends, and small groups requiring convenient pickup, flexible sightseeing, and direct return transportation."
},
{
"name": "Pune to Lonavala Private Tour Package",
"description": "Book Pune to Lonavala Private Tour Package for a personalized sightseeing journey with exclusive chauffeur-driven transportation. Enjoy comfortable AC sedan travel, flexible pickup, customized sightseeing plans, practical luggage space, and convenient return arrangements for families, couples, friends, and tourists."
},
{
"name": "Pune to Lonavala Travel Package",
"description": "Choose Pune to Lonavala Travel Package for convenient private transportation planned around your preferred travel schedule. Enjoy professional chauffeur service, comfortable AC sedan travel, flexible sightseeing arrangements, and suitable one-way or round-trip options for families, couples, tourists, and groups."
},
{
"name": "Pune to Lonavala Group Tour Package",
"description": "Book Pune to Lonavala Group Tour Package for comfortable private transportation for friends, families, and small groups. Enjoy spacious sedan seating, AC interiors, professional chauffeur service, convenient pickup, flexible sightseeing, and return travel arrangements for your Lonavala group journey."
},
{
"name": "Pune to Lonavala AC Cab Package",
"description": "Choose Pune to Lonavala AC Cab Package for a comfortable private journey in a well-maintained air-conditioned sedan with professional chauffeur service. The package is suitable for sightseeing, family travel, weekend trips, couples, tourists, day tours, and convenient round-trip transportation."
},
{
"name": "Pune to Lonavala Couple Tour Package",
"description": "Book Pune to Lonavala Couple Tour Package for a comfortable and private journey with an AC sedan and professional chauffeur. Enjoy flexible pickup, sightseeing arrangements, convenient return travel, and a relaxed transportation option for couples planning a weekend getaway or day trip."
},
{
"name": "Pune to Lonavala Online Tour Booking",
"description": "Make Pune to Lonavala Online Tour Booking for convenient scheduled transportation and private sightseeing arrangements. Choose a comfortable AC sedan and plan pickup, travel, sightseeing, and return according to your preferred itinerary for family trips, couple tours, weekend holidays, and tourist journeys."
},
{
"name": "Pune to Lonavala Sedan Cab",
"description": "Book Pune to Lonavala Sedan Cab for comfortable private transportation with professional chauffeur service, air-conditioned interiors, convenient seating, and practical luggage space. The sedan is suitable for individuals, couples, families, tourists, weekend travelers, sightseeing trips, and outstation journeys."
},
{
"name": "Pune to Lonavala Sedan Cab Service",
"description": "Choose Pune to Lonavala Sedan Cab Service for reliable and comfortable outstation transportation with experienced chauffeurs and well-maintained AC vehicles. The service is suitable for one-way transfers, round trips, sightseeing, family travel, weekend holidays, day trips, and private journeys."
},
{
"name": "Pune to Lonavala Taxi Service",
"description": "Book Pune to Lonavala Taxi Service for dependable private transportation with a professional chauffeur and comfortable air-conditioned sedan. Enjoy convenient pickup and destination drop, flexible travel arrangements, and suitable transportation for families, couples, tourists, friends, and business travelers."
}
],
"tableData": [
["Lonavala Sedan Cab from Pune", "Pune to Lonavala Taxi Fare"],
["Pune to Lonavala Tourist Taxi", "Pune to Lonavala Weekend Trip Cab"],
["Pune to Lonavala Outstation Taxi", "Pune to Lonavala Sedan Car Hire"],
["Pune to Lonavala Family Tour Cab", "Pune to Lonavala Day Trip Cab"],
["Pune to Lonavala Budget Cab", "Pune to Lonavala Cab Tour Package"],
["Pune to Lonavala Tour Package", "Pune to Lonavala Sightseeing Package"],
["Pune to Lonavala Cab Package", "Pune to Lonavala Tourist Package"],
["Pune to Lonavala One Day Tour Package", "Pune to Lonavala Family Tour Package"],
["Pune to Lonavala Taxi Package", "Pune to Lonavala Holiday Package"],
["Pune to Lonavala Weekend Tour Package", "Pune to Lonavala Darshan Package"],
["Pune to Lonavala Cab Booking Package", "Pune to Lonavala Round Trip Package"],
["Pune to Lonavala Tourist Cab Package", "Pune to Lonavala Private Tour Package"],
["Pune to Lonavala Travel Package", "Pune to Lonavala Group Tour Package"],
["Pune to Lonavala AC Cab Package", "Pune to Lonavala Couple Tour Package"],
["Pune to Lonavala Online Tour Booking", "Pune to Lonavala Sedan Cab"],
["Pune to Lonavala Sedan Cab Service", "Pune to Lonavala Taxi Service"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Lonavala Sedan Cabs for a Comfortable Hill Trip",
    WhyChoosedescription: "Garud Cab Service provides private sedan cabs from Pune to Lonavala for weekend getaways, family holidays, couple trips, sightseeing plans, and travellers who prefer a direct and comfortable journey."
  },
  {
    WhyChooseheading: "Scenic Road Travel with a Private Sedan",
    WhyChoosedescription: "Enjoy the journey from Pune to Lonavala in a dedicated sedan with comfortable seating, convenient luggage space, and the freedom to plan your departure around your schedule."
  },
  {
    WhyChooseheading: "Ideal for Couples & Small Families",
    WhyChoosedescription: "A sedan is a practical choice for couples and small families travelling to Lonavala for a short vacation, romantic getaway, family outing, or relaxed weekend break."
  },
  {
    WhyChooseheading: "Flexible One-Way & Return Bookings",
    WhyChoosedescription: "Choose one-way transportation if you need a direct drop in Lonavala, or reserve a round-trip sedan when your plans include returning to Pune after sightseeing or an overnight stay."
  },
  {
    WhyChooseheading: "Explore Lonavala Attractions",
    WhyChoosedescription: "Plan your sightseeing around popular destinations such as Bhushi Dam, Tiger Point, Lion's Point, Rajmachi Point, Karla Caves, Bhaja Caves, and Pawna Lake according to your preferred itinerary."
  },
  {
    WhyChooseheading: "Pickup from Any Preferred Pune Location",
    WhyChoosedescription: "Begin your Lonavala trip from your home, hotel, office, residential society, railway station area, or another convenient pickup point in Pune."
  },
  {
    WhyChooseheading: "Convenient for Weekend & Monsoon Trips",
    WhyChoosedescription: "Whether you are planning a monsoon outing, weekend holiday, family picnic, honeymoon, or one-day sightseeing trip, a private sedan provides flexibility throughout your travel schedule."
  },
  {
    WhyChooseheading: "Book Your Lonavala Sedan with Garud",
    WhyChoosedescription: "Share your Pune pickup location, Lonavala destination, travel date, passenger count, sightseeing requirements, and one-way or return preference with Garud Cab Service to arrange your sedan."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Lonavala Sedan Cabs?",
    answer: "Yes, Garud Cab Service provides sedan cabs from Pune to Lonavala for weekend trips, family holidays, couples, sightseeing, and other outstation travel requirements."
  },
  {
    question: "Can I book a one-way sedan from Pune to Lonavala?",
    answer: "Yes, one-way sedan cab service is available for passengers who need direct transportation from Pune to Lonavala."
  },
  {
    question: "Can I book a round-trip Lonavala sedan?",
    answer: "Yes, round-trip sedan arrangements can be planned according to your sightseeing schedule, hotel stay, and preferred return timing."
  },
  {
    question: "Is a sedan suitable for a Lonavala family trip?",
    answer: "Yes, sedans are suitable for couples and small families who want private transportation with comfortable seating and convenient luggage space."
  },
  {
    question: "Can I include Lonavala sightseeing with the cab?",
    answer: "Yes, sightseeing can be included in your itinerary with places such as Bhushi Dam, Tiger Point, Lion's Point, Rajmachi Point, Karla Caves, Bhaja Caves, and Pawna Lake."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can the sedan drop me directly at my Lonavala hotel?",
    answer: "Yes, direct drop-off can be arranged at your preferred hotel, resort, homestay, or another accessible destination in Lonavala."
  },
  {
    question: "Can I book a same-day return sedan?",
    answer: "Yes, a same-day return arrangement can be discussed according to your departure time, sightseeing plans, and preferred return schedule."
  },
  {
    question: "Is Pune to Lonavala sedan service suitable for couples?",
    answer: "Yes, a private sedan is a convenient option for couples planning a romantic getaway, weekend trip, honeymoon, or sightseeing visit to Lonavala."
  },
  {
    question: "How can I book a Pune to Lonavala Sedan Cab?",
    answer: "Share your Pune pickup location, travel date, passenger details, Lonavala destination, sightseeing requirements, and trip type with Garud Cab Service to arrange your sedan."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay More",
    feedback: "We booked a sedan from Pune to Lonavala for a weekend trip. The private cab was comfortable and made it easy for us to manage our sightseeing schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "My family booked a sedan for our Lonavala outing. The pickup from Pune was convenient and the car was comfortable for our small group and luggage.",
    rating: 5
  }
];




  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Sedan Cabs",
  "image": "https://garudcabs.com/assets/images/pune-to-lonavala-sedan-cabs.webp",
  "description": "Book Pune to Lonavala Sedan Cabs with Garud Cab for comfortable, safe, and convenient travel. Get Sedan cab and taxi services for Lonavala sightseeing, weekend trips, family tours, and outstation journeys from Pune, with car hire options and convenient pickup and drop facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-lonavala-sedan-cabs"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Lonavala Sedan Cabs | Weekend & Tourist Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Lonavala Sedan Cabs with Garud Cab for comfortable weekend and sightseeing travel. Get Sedan taxi, car hire, family tour, tourist, and outstation cab services from Pune to Lonavala with convenient pickup and drop."
  />

  <meta
    name="keywords"
    content="Lonavala Sedan Cab from Pune, Pune to Lonavala Taxi Fare, Pune to Lonavala Tourist Taxi, Pune to Lonavala Weekend Trip Cab, Pune to Lonavala Outstation Taxi, Pune to Lonavala Sedan Car Hire, Pune to Lonavala Family Tour Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolonavalasedancab;